import { Link } from 'react-router-dom';
import { APP_CONFIG } from '@/config/app.config';
import ApperIcon from '@/components/ApperIcon';
import { Button } from '@/components/ui/button';

export const route = { path: '/', layout: 'public', access: 'public' };

export default function Home() {
  return (
    <main className="mx-auto flex min-h-svh max-w-5xl flex-col justify-between px-5 py-8 sm:px-10">
      <header className="flex items-center gap-3">
        <span className="flex size-11 items-center justify-center rounded-full bg-primary text-primary-foreground"><ApperIcon name="Coffee" size={22} /></span>
        <div><p className="font-heading text-lg font-semibold">{APP_CONFIG.name}</p><p className="text-xs text-muted-foreground">Owner workspace</p></div>
      </header>
      <section className="grid gap-10 py-16 md:grid-cols-[1.1fr_0.9fr] md:items-center">
        <div className="space-y-6">
          <p className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1.5 text-sm text-muted-foreground"><span className="size-2 rounded-full bg-success" />Secure store operations</p>
          <h1 className="max-w-xl font-heading text-5xl font-semibold leading-[1.05] tracking-tight sm:text-6xl">A calmer way to run your tea and coffee store.</h1>
          <p className="max-w-lg text-lg leading-8 text-muted-foreground">Manage your catalog, stock, orders, customer records, offers and store settings from one owner-only workspace.</p>
          <Button asChild className="min-h-11 px-5"><Link to="/login">Open owner sign in <ApperIcon name="ArrowRight" size={17} /></Link></Button>
        </div>
        <aside className="relative overflow-hidden rounded-2xl border border-border bg-card p-6 sm:p-8">
          <div className="absolute right-0 top-0 h-full w-2 bg-highlight" />
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">First run</p>
          <h2 className="mt-3 font-heading text-2xl font-semibold">Your live data starts empty.</h2>
          <p className="mt-3 leading-7 text-muted-foreground">Add verified products and stock when ready. No sample customers, orders or inventory were inserted.</p>
          <div className="mt-7 grid grid-cols-2 gap-3 text-sm">
            <div className="rounded-xl bg-muted p-4"><p className="font-semibold">₹70</p><p className="mt-1 text-muted-foreground">Shipping below ₹999</p></div>
            <div className="rounded-xl bg-muted p-4"><p className="font-semibold">₹999+</p><p className="mt-1 text-muted-foreground">Free shipping threshold</p></div>
          </div>
        </aside>
      </section>
      <footer className="border-t border-border py-5 text-xs text-muted-foreground">Customer checkout, OTP and payment integrations stay off until their providers and server checks are configured.</footer>
    </main>
  );
}